import React, { useCallback, useMemo } from "react";
import { TextLink } from "@folio/stripes/components";
function renderValue(value) {
    if (typeof value === "string" || typeof value === "number")
        return value;
    if (React.isValidElement(value))
        return value;
    return String(value !== null && value !== void 0 ? value : "");
}
export function useTableColumns(columns, wrapInteractive) {
    if (wrapInteractive === void 0) { wrapInteractive = false; }
    var getColumnId = useCallback(function (col) { var _a; return (_a = col.id) !== null && _a !== void 0 ? _a : col.key; }, []);
    var columnMapping = useMemo(function () {
        return columns.reduce(function (acc, col) {
            acc[getColumnId(col)] = col.name;
            return acc;
        }, {});
    }, [columns, getColumnId]);
    var visibleColumns = useMemo(function () { return columns.map(getColumnId); }, [columns, getColumnId]);
    var formatter = useMemo(function () {
        return columns.reduce(function (acc, column) {
            acc[getColumnId(column)] = function (rowItem) {
                var content;
                if (column.cellRenderer) {
                    var rendered = column.cellRenderer(rowItem);
                    content =
                        column.clickable && column.onClick ? (React.createElement(TextLink, { onClick: function () { return column.onClick(rowItem); } }, rendered)) : (rendered);
                }
                else {
                    var cellValue = rowItem[column.key];
                    var isClickable = column.clickable &&
                        column.onClick &&
                        (typeof cellValue === "string" ||
                            typeof cellValue === "number");
                    content =
                        isClickable && column.onClick ? (React.createElement(TextLink, { onClick: function () { return column.onClick(rowItem); } }, cellValue)) : (renderValue(cellValue));
                }
                if (wrapInteractive && column.stopDragPropagation) {
                    return (React.createElement("span", { onPointerDown: function (e) { return e.stopPropagation(); } }, content));
                }
                return content;
            };
            return acc;
        }, {});
    }, [columns, getColumnId, wrapInteractive]);
    var sortableFields = useMemo(function () { return columns.filter(function (col) { return col.sortable; }).map(getColumnId); }, [columns, getColumnId]);
    var nonInteractiveHeaders = useMemo(function () { return columns.filter(function (col) { return !col.sortable; }).map(getColumnId); }, [columns, getColumnId]);
    var columnWidths = useMemo(function () {
        var widths = {};
        columns.forEach(function (col) {
            if (col.width !== undefined) {
                widths[getColumnId(col)] = col.width;
            }
        });
        return Object.keys(widths).length > 0 ? widths : undefined;
    }, [columns, getColumnId]);
    return {
        columnMapping: columnMapping,
        visibleColumns: visibleColumns,
        formatter: formatter,
        columnWidths: columnWidths,
        sortableFields: sortableFields,
        nonInteractiveHeaders: nonInteractiveHeaders,
    };
}
